import * as yup from "yup";
import { nameof } from "ts-simple-nameof";
import { VehicleValidationRuleObject } from "../vehicle";
import { VehicleDto, VehiclePriceDto } from "../../dtos";
import { customNullable } from "..";


// zalezi na poradi - v tomto poradi se pak mezi errory preklikava
export const VehicleValidationSchema = yup.object().shape(
    {
        ...VehicleValidationRuleObject,
        [nameof<VehicleDto>(x => x.usage)]: yup.string().optional(),
        [nameof<VehicleDto>(x => x.pocetMistSezeni)]: customNullable(yup.number()).optional(),
        [nameof<VehiclePriceDto>(x => x.price)]: customNullable(yup.number()).required("Zadejte cenu vozdila z faktury"),
    },
    [
        // osetreni cyclic dependency vznikajici pri pouziti when... is... then...
        ["vin", "vin"],
        ["licensePlate", "licensePlate"]
    ]
) as any